import { ApiRoutes } from '@/services/ApiRoutes.js';
import { BackendAPI } from '@/services/BackendAPI.js';

export default {
  all(data = {}) {
    return BackendAPI('get', ApiRoutes.course.all(), data);
  },
  get(id) {
    return BackendAPI('get', ApiRoutes.course.get(id));
  },
  create(data) {
    return BackendAPI('post', ApiRoutes.course.create(), data);
  },
  update(id, data) {
    return BackendAPI('put', ApiRoutes.course.update(id), data);
  },
  frozen(id, data = {}) {
    return BackendAPI('put', ApiRoutes.course.frozen(id), data);
  },
};
